import { HawaPanel } from '../types'

import component from './text.component.vue'
import editor from './text.editor.vue'
// import { Attribute } from './types'

export default class TextObject implements HawaPanel {
  name = 'TextObject'
  title = 'Text Object'
  component = component
  editor = editor
  snapshot = {
    DeletedAt: null,
    title: 'IO Field',
    component: 'IOField',
    query: [],
    layout: { h: 9, i: '1597804192412', moved: false, w: 16, x: 16, y: 18 },
    attributes: {
      panelHeader: {
        show: false,
        style: {},
      },
      headerShow: true,
      labelTextStyle: {
        'vertical-align': 'middle',
      },
      labelStyle: {
        'background-color': '#ffffff',
        border: '',
        color: '#0033ff',
        'font-size': '30px',
        padding: '10px',
        'text-align': 'left',
        width: '180px',
      },
      labelText: '<b>T</b>ext',
    },
  }

  init = {
    DeletedAt: null,
    title: 'IO Field',
    component: 'IOField',
    query: [],
    layout: { h: 9, i: '1597804192412', moved: false, w: 16, x: 16, y: 18 },
    attributes: {
      panelHeader: {
        show: false,
        style: {},
      },
      headerShow: true,
      labelTextStyle: {
        'vertical-align': 'middle',
      },
      labelStyle: {
        'background-color': '#ffffff',
        border: '',
        color: '#0033ff',
        'font-size': '30px',
        padding: '10px',
        'text-align': 'left',
        width: '100%',
      },
      labelText: '<b>T</b>ext',
    },
  }
}
